import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Tabs, Tab } from '@mui/material';
import { TabsHeader as TabsContainer } from '../../components/tabs/TabsHeader';
import { CertifiedTab } from './CertifiedTab';
import { UncertifiedTab } from './UncertifiedTab';
import { IrrigationTab } from './IrrigationTab';
import { actions } from '../../store/dux/field-boundary-management-dux';
import { selectors as growerSelectors } from '../../store/dux/grower-dux';
import { usePermission } from '../../hooks/use-permission';
import { useContext } from './context';

const tabStyle = { minWidth: 160 };
export function FieldBoundaryManagementTabs() {
  const dispatch = useDispatch();
  const growerId = useSelector(growerSelectors.selectedId);
  const canManageIrrigation = usePermission('MANAGE_IRRIGATION');
  const { tab, setTab } = useContext();

  useEffect(syncFieldsEffect, [dispatch, growerId]);

  return (
    <Box
      sx={{ mt: '7px', display: 'flex', height: '100%', overflow: 'hidden' }}
    >
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          overflowX: 'auto',
        }}
      >
        <UncertifiedTab
          isActive={tab === 'UNCERTIFIED'}
          renderTabs={renderTabs}
        />
        <CertifiedTab isActive={tab === 'CERTIFIED'} renderTabs={renderTabs} />
        {canManageIrrigation ? (
          <IrrigationTab
            isActive={tab === 'IRRIGATION'}
            renderTabs={renderTabs}
          />
        ) : null}
      </Box>
    </Box>
  );

  function renderTabs() {
    return (
      <TabsContainer>
        <Tabs value={tab} onChange={(e, selectedTab) => setTab(selectedTab)}>
          <Tab sx={tabStyle} label="Uncertified" value="UNCERTIFIED" />
          <Tab sx={tabStyle} label="Certified" value="CERTIFIED" />
          {canManageIrrigation ? (
            <Tab sx={tabStyle} label="Irrigation" value="IRRIGATION" />
          ) : null}
        </Tabs>
      </TabsContainer>
    );
  }

  function syncFieldsEffect() {
    dispatch(actions.loadFields(growerId));
  }
}
